import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropTypes(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/query/fetch_crop_types/${packing_house_process_id}`
    );
  },
  fetchCropVarieties(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/query/fetch_crop_varieties/${packing_house_process_id}`
    );
  },
  fetchAgroExporters(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/query/fetch_agro_exporters/${packing_house_process_id}`
    );
  },
  fetchProducersOrganizations(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/query/fetch_producers_organizations/${packing_house_process_id}`
    );
  },
  fetchCropHarPackages(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/query/fetch_crop_har_packages/${packing_house_process_id}`
    );
  }
};
